module.exports = __webpack_public_path__ + "img/DataSecurityselect.b2ff12f1.svg";